import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

export const storeCategoryList = (data) => {
	return {
		type: Types.STORE_CATEGORY_LIST,
		payload: data
	};
};

export const fetchSubCategoryList =
	(params = '') =>
	async (dispatch) => {
		await ApiClient.GET('fetchSubCategory', params).then((response) => {
			let tmpCategories = [];
			for (let cat of response.data) {
				for (let item of cat.subCategoryResponseList) {
					tmpCategories.push({ id: item.id, name: item.name, isPrimary: item.isPrimary });
				}
			}

			dispatch(storeCategoryList(tmpCategories));
		});
	};
